import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { CopyService } from '../../services/copy.service';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { RegistrationService } from 'src/app/services/registration.service';
import { VariablesService } from 'src/app/services/variables.service';

@Component({
    templateUrl: './invitation.component.html',
    standalone: false
})
export class InvitationComponent implements OnInit {

  constructor(
    private navigationService: NavigationService,
    private copyService: CopyService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private registrationService: RegistrationService,
    private variablesService: VariablesService

  ) {
    this.attendee = this.registrationService.getAttendee({});

    this.varTrack = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varTrack.ID,
      {}
    );

    this.dayAttending = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varSBSDayAttending.ID,
      {}
    );
  }

  isSubmitting = false;
  isError = false;
  isFormCompleted = false;
  invitation = {
    isAttending: undefined,
    declineOption: undefined,
    declineComment: undefined
  };
  attendee;
  setattendeetype;
  varLOB;
  varSponsor;
  varSponsorUse;
  varTrack;
  varSponsorDateAttend;
  sponsordayvalues;
  dayAttending;

  declineRadios = [
    {
      value: "Travel time too long (distance)",
      display: "Travel time too long (distance)"
    },
    {
      value: "Flight too expensive",
      display: "Flight too expensive"
    },
    {
      value: "Unable to take the time away from clients",
      display: "Unable to take the time away from clients"
    },
    {
      value: "Don't find value in this conference",
      display: "Don't find value in this conference"
    },
    {
      value: "Dates not convenient for me to attend",
      display: "Dates not convenient for me to attend"
    },
    {
      value: 'other',
      display: 'Other'
    }
  ];

  dayAttendingRadios = [
    {
      value: "Sunday, August 9, 2026",
      display: "Sunday, August 9, 2026"
    },
    {
      value: "Monday, August 10, 2026",
      display: "Monday, August 10, 2026"
    },
    {
      value: "Tuesday, August 11, 2026",
      display: "Tuesday, August 11, 2026"
    }
  ];

  ngOnInit(): void {}

  forward(form) {
    this.isSubmitting = true;
    this.isFormCompleted = true;

    if ((this.invitation.isAttending|| this.varTrack.Value === 'Sponsor') && form.valid) {
      this.navigationService.forward();
    } 
    else if (this.invitation.isAttending === false) {
      if (this.attendee.PAXTypeNo === 20 || this.attendee.PAXTypeNo === 21 || this.attendee.PAXTypeNo === 29) {
        this.invitation.declineOption = 'other';
      }

      if(this.invitation.declineOption === undefined)
      {
        this.isError = true;
        this.isSubmitting = false;
      }
      else{
          let declinereason = this.invitation.declineOption;
          if (this.invitation.declineOption === 'other' && this.invitation.declineComment === undefined) {
            this.isError = true;
            this.isSubmitting = false;
          }
          else{
            if (this.invitation.declineOption === 'other')
            {
              declinereason = this.invitation.declineComment;
            }
             this.authenticationService
            .updateProfile('CANCELLED', declinereason)
            .subscribe(() => {
            this.router.navigate(['decline']);
          });
        }
      }
    }
    else {
      this.isError = true;
      this.isSubmitting = false;
    }
  }

  back() {
    this.navigationService.back();
  }
}
